// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-info[data-v-fc5a983e]{font-family:Source Sans\\ 3;font-size:24px;font-style:normal;font-weight:400;line-height:34px;letter-spacing:0;text-align:left;color:#fff;text-transform:uppercase}.player-controls[data-v-fc5a983e],.player-info[data-v-fc5a983e]{background:rgba(0,0,0,.6)}.playlist[data-v-fc5a983e]{margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
